import { normalizeAudioPlayerData } from './audioPlayer.js';
import {
	formatPayPreviewDuration,
	getPayMediaUnlockKey,
	isPayMediaUnlocked,
	normalizePayMediaPriceFields,
	setPayMediaUnlocked,
} from './payMediaCommon.js';
import { LOCAL_ASSET } from './localAssets.js';

export const PAY_AUDIO_PLAYER_TYPE = 'pay-audio-player';
const UNLOCK_PREFIX = 'pay-audio-player';

// 仅剥离当前付费音频播放器未支持的字段，title 保留以便在播放器下方展示
const REMOVED_TEXT_FIELDS = ['subtitle', 'titleColor', 'subtitleColor'];

function stripAudioTextFields(data = {}) {
	const next = { ...data };
	REMOVED_TEXT_FIELDS.forEach((key) => {
		delete next[key];
	});
	return next;
}

export function getPayAudioPlayerDefaults(extra = {}) {
	return normalizePayAudioPlayerData({
		audio: {
			id: 'da-21001',
			filename: '示例音频.mp3',
			filesize: '2.34MB',
			filesize_byte: 2.34 * 1024 * 1024,
			duration: 103,
			durationText: '01:43',
			previewUrl: '',
			url: LOCAL_ASSET.payAudioPlayer,
			local: false,
		},
		...extra,
	});
}

export function getPayAudioPlayerPreviewDefaults() {
	return getPayAudioPlayerDefaults();
}

export function normalizePayAudioPlayerData(data = {}) {
	const base = stripAudioTextFields(normalizeAudioPlayerData(data));
	const duration = base.audio?.duration || 0;
	const payFields = normalizePayMediaPriceFields(data, {
		defaultButtonText: '立即解锁收听',
		maxPreviewDuration: duration || 9999,
	});
	return {
		...base,
		...payFields,
		freePreviewDuration: duration
			? Math.min(payFields.freePreviewDuration, duration)
			: payFields.freePreviewDuration,
	};
}

export function isPayAudioPlayerBlock(type) {
	return type === PAY_AUDIO_PLAYER_TYPE;
}

export function getPayAudioPlayerUnlockKey(blockId) {
	return getPayMediaUnlockKey(blockId, UNLOCK_PREFIX);
}

export function isPayAudioPlayerUnlocked(blockId) {
	return isPayMediaUnlocked(blockId, UNLOCK_PREFIX);
}

export function setPayAudioPlayerUnlocked(blockId, unlocked = true) {
	setPayMediaUnlocked(blockId, UNLOCK_PREFIX, unlocked);
}

export function getPayAudioPlayerPreviewHint(data = {}) {
	const normalized = normalizePayAudioPlayerData(data);
	return `可免费试听前 ${formatPayPreviewDuration(normalized.freePreviewDuration)}，解锁后可听完整内容`;
}
